import { useCallback } from "react";

import { useModalDialog, type ModalDialogProps } from "@skilitics/designer-ui-components";
import type { DesignerNodeData } from "@skilitics/nautilus-core-designer-data";

import type { ImportNodeTarget, NodeSelectionCriteria } from "../../../library";
import type { ImportTargetLayout } from "../../../slots/useCanImportHere";
import type { useImportNodeDesign } from "../../../slots/useImportNodeDesign";
import { BrowseTemplates } from "./BrowseTemplates";

export const browseTemplatesDialogId = "browse-templates-dialog";

export const browseTemplatesModalDialogProps: ModalDialogProps = {
  maxWidth: "lg",
  slotProps: {
    paper: {
      sx: {
        borderRadius: "10px",
        overflow: "hidden",
        maxHeight: "800px",
        height: "90vh",
      },
    },
  },
};

type OnSelected = (node: DesignerNodeData) => void;

type Props = {
  criteria: NodeSelectionCriteria;
  target: ImportNodeTarget;
  targetLayout?: ImportTargetLayout;
  onSelected?: OnSelected;
} & Parameters<typeof useImportNodeDesign>[0];

export const useBrowseTemplates = (options: Props) => {
  const { openModalDialog, closeModalDialog } = useModalDialog();

  const handleClose = useCallback(() => closeModalDialog(browseTemplatesDialogId), [closeModalDialog]);

  const handleSelected: OnSelected = useCallback(
    (node) => {
      options.onSelected?.(node);
      handleClose();
    },
    [handleClose, options],
  );

  return () => {
    openModalDialog(
      {
        ...browseTemplatesModalDialogProps,
        children: <BrowseTemplates {...options} onSelected={handleSelected} onClose={handleClose} />,
      },
      browseTemplatesDialogId,
    );
  };
};
